import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ShieldAlert, X } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import api from "@/lib/api";

/**
 * AnonymityNotice — Hinweis vor Veröffentlichung (Beitrag / MP-Artikel / Profilbild).
 * Wird standardmäßig JEDES MAL angezeigt. Jeder Nutzer kann ihn PRO STELLE (location)
 * dauerhaft ausblenden (persistiert am User: hidden_anon_notices).
 */
export function AnonymityNotice({ location }) {
  const { t } = useTranslation();
  const { user, refreshUser } = useAuth();
  const [sessionHidden, setSessionHidden] = useState(false);
  const [saving, setSaving] = useState(false);

  const permanentlyHidden = (user?.hidden_anon_notices || []).includes(location);
  if (permanentlyHidden || sessionHidden) return null;

  const dismissForever = async () => {
    setSaving(true);
    try {
      await api.post("/me/anon-notice-dismiss", { location });
      await refreshUser();
    } catch {
      setSessionHidden(true);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid={`anonymity-notice-${location}`} className="relative border border-amber-300 bg-amber-50 rounded-lg p-3 pr-8">
      <button
        data-testid={`anonymity-notice-close-${location}`}
        onClick={() => setSessionHidden(true)}
        aria-label={t("anonymity_notice.close")}
        className="absolute top-2 right-2 p-1 text-amber-700/70 hover:text-amber-900">
        <X size={14} />
      </button>
      <div className="flex gap-2">
        <ShieldAlert size={16} className="text-amber-600 shrink-0 mt-0.5" />
        <div className="space-y-2">
          <p className="text-[11px] leading-snug text-amber-900">{t("anonymity_notice.body")}</p>
          <button
            data-testid={`anonymity-notice-hide-${location}`}
            onClick={dismissForever}
            disabled={saving}
            className="text-[10px] font-medium text-amber-800 underline underline-offset-2 disabled:opacity-50">
            {t("anonymity_notice.hide_forever")}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AnonymityNotice;
